<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="max-w-md w-full mx-auto text-center px-4">
      <div class="mb-8">
        <!-- 404 Icon -->
        <div class="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 20a7.962 7.962 0 01-6-2.709M3 15V9a6 6 0 1112 0v6c0 .105-.026.207-.077.296" />
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-6xl font-bold text-text-primary mb-4">404</h1>

        <!-- Error Title -->
        <h2 class="text-2xl font-semibold text-text-primary mb-4">Page Not Found</h2>

        <!-- Error Description -->
        <p class="text-text-secondary mb-8">
          Sorry, the page you are looking for could not be found. It might have been removed, renamed, or doesn't exist.
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <button
            @click="goBack"
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Go Back
        </button>

        <router-link
            to="/"
            class="block w-full bg-background-light hover:bg-background-lighter text-text-primary font-medium py-3 px-6 rounded-md border border-background-lighter transition-colors"
        >
          Return to Home
        </router-link>
      </div>

      <!-- Additional Help -->
      <div class="mt-8 pt-8 border-t border-background-lighter">
        <p class="text-sm text-text-secondary mb-4">Need help? Try these options:</p>
        <div class="flex justify-center space-x-6 text-sm">
          <router-link to="/contact" class="text-primary hover:underline">Contact Us</router-link>
          <router-link to="/faq" class="text-primary hover:underline">FAQ</router-link>
          <router-link to="/about" class="text-primary hover:underline">About</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack() {
      // Check if there's history to go back to
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  },
  mounted() {
    // Set page title
    document.title = '404 - Page Not Found | Eskrag';
  }
}
</script>
